export default "__VITE_ASSET__CYTe0Hmt__"